export const veeValidateLocale = {
    en: {
        names: {
            credential: 'Credential',
        },
    },
    vi: {
        names: {
            credential: 'email',
        },
    },
};
